export default __webpack_public_path__ + "static/media/screen7.25ad3d32.png";